import React from "react";
import { hasEnded } from "../../../utils/dateUtils";
import CountdownStatus from "./CountdownStatus";

// LosHeat.TV no tiene Universal Links (iOS) ni App Links (Android)
// configurados en su dominio, así que no hay forma verificada de forzar
// la apertura de la app. En Android sí podemos usar un intent:// con el
// package id (sacado del link de Google Play) que abre la app si está
// instalada y cae solo al Play Store si no — es el patrón que recomienda
// Google para este caso. En iOS, sin un custom URL scheme confirmado por
// LosHeat.TV, lo más honesto es mandar directo al App Store.
const getVoteHref = (campaign) => {
  if (campaign.voteUrl) return campaign.voteUrl;
  const appLinks = campaign.appLinks;
  const ua = typeof navigator !== "undefined" ? navigator.userAgent : "";

  if (/android/i.test(ua) && appLinks?.android) {
    const packageId = new URL(appLinks.android).searchParams.get("id");
    if (packageId) {
      return `intent://losheat.tv/#Intent;scheme=https;package=${packageId};S.browser_fallback_url=${encodeURIComponent(
        appLinks.android
      )};end`;
    }
    return appLinks.android;
  }

  if (/iPhone|iPad|iPod/i.test(ua) && appLinks?.ios) {
    return appLinks.ios;
  }

  return "/ayuda-votacion";
};

const VotingHero = ({ campaign }) => {
  const voteHref = getVoteHref(campaign);
  const ended = hasEnded(campaign.endTime);
  const voteCount = campaign.categories?.length || 0;

  return (
    <div className="px-5 py-6 text-center space-y-4 bg-white/[0.92] rounded-[20px] border-2 border-pink-300 shadow-card">
      <h1 className="text-xl font-extrabold leading-snug text-brand-primary">
        {campaign.title}
      </h1>

      <div>
        <p className="text-sm font-semibold text-brand-dark">
          {campaign.nomineeIntro}
        </p>
        <div className="mt-3 space-y-2">
          {campaign.categories.map((cat) => (
            <div
              key={cat.name}
              className="rounded-xl px-4 py-2 bg-violet-300/[0.12] border border-violet-300"
            >
              <p className="text-sm font-bold text-brand-primary">
                {cat.emoji || "⭐"} {cat.name}
              </p>
              <p className="text-xs text-gray-500">({cat.nominee})</p>
            </div>
          ))}
        </div>
      </div>

      <CountdownStatus endTime={campaign.endTime} />

      <div className="py-2">
        {ended ? (
          <span className="inline-block py-2 px-8 rounded-full font-bold bg-gray-200 text-gray-500 cursor-not-allowed">
            Votación cerrada
          </span>
        ) : (
          <a
            href={voteHref}
            {...(campaign.voteUrl
              ? { target: "_blank", rel: "noopener noreferrer" }
              : {})}
            className="inline-block py-2 px-8 rounded-full font-bold active:scale-95 transition-transform bg-custom-blue shadow-accent text-sky-900"
          >
            Votar ahora
          </a>
        )}
      </div>

      {campaign.voteHint?.length > 0 ? (
        <div>
          {campaign.voteHint.map((line) => (
            <p key={line} className="text-xs italic text-brand-muted">
              {line}
            </p>
          ))}
        </div>
      ) : voteCount > 0 && (
        <div>
          <p className="text-xs italic text-brand-muted">
            💖 Puedes apoyar con {voteCount} voto{voteCount === 1 ? "" : "s"}{" "}
            cada día
          </p>
          <p className="text-xs italic text-brand-muted">
            (1 por cada categoría)
          </p>
          {!ended && (
            <p className="text-xs italic text-brand-muted mt-1">
              🔄 Regresa mañana para volver a votar.
            </p>
          )}
        </div>
      )}

      <p>
        <a
          href="/ayuda-votacion"
          className="text-sm font-semibold underline text-brand-primary"
        >
          ✨ ¿Primera vez votando? Aquí te explico cómo, bb.
        </a>
      </p>
    </div>
  );
};

export default VotingHero;
